import React, { Component } from 'react';
import Player from './Player.js';
import { defaultProps, DEPRECATED_CONFIG_PROPS, propTypes } from './props.js';
import { getConfig, isEqual, omit } from './utils.js';
import 'prop-types';
import 'lodash';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
const SUPPORTED_PROPS = Object.keys(propTypes);
function createSinglePlayer(activePlayer) {
  var _a;
  return _a = class extends Component {
    constructor() {
      super(...arguments);
      __publicField(this, "config", getConfig(this.props, defaultProps, true));
      __publicField(this, "getDuration", () => {
        if (!this.player)
          return null;
        return this.player.getDuration();
      });
      __publicField(this, "getCurrentTime", () => {
        if (!this.player)
          return null;
        return this.player.getCurrentTime();
      });
      __publicField(this, "getSecondsLoaded", () => {
        if (!this.player)
          return null;
        return this.player.getSecondsLoaded();
      });
      __publicField(this, "getInternalPlayer", (key = "player") => {
        if (!this.player)
          return null;
        return this.player.getInternalPlayer(key);
      });
      __publicField(this, "seekTo", (fraction, type) => {
        if (!this.player)
          return null;
        this.player.seekTo(fraction, type);
      });
      __publicField(this, "ref", (player) => {
        this.player = player;
      });
    }
    shouldComponentUpdate(nextProps) {
      return !isEqual(this.props, nextProps);
    }
    componentDidUpdate() {
      this.config = getConfig(this.props, defaultProps);
    }
    render() {
      const { forceVideo, forceAudio, forceHLS, forceDASH } = this.config.file;
      const skipCanPlay = forceVideo || forceAudio || forceHLS || forceDASH;
      if (!activePlayer.canPlay(this.props.url) && !skipCanPlay) {
        return null;
      }
      const { style, width, height, wrapper: Wrapper } = this.props;
      const otherProps = omit(this.props, SUPPORTED_PROPS, DEPRECATED_CONFIG_PROPS);
      return /* @__PURE__ */ React.createElement(Wrapper, __spreadValues({ style: __spreadProps(__spreadValues({}, style), { width, height }) }, otherProps), /* @__PURE__ */ React.createElement(Player, __spreadProps(__spreadValues({}, this.props), { ref: this.ref, activePlayer, config: this.config })));
    }
  }, __publicField(_a, "displayName", `${activePlayer.displayName}Player`), __publicField(_a, "propTypes", propTypes), __publicField(_a, "defaultProps", defaultProps), __publicField(_a, "canPlay", activePlayer.canPlay), _a;
}

export { createSinglePlayer as default };
//# sourceMappingURL=singlePlayer.js.map
